export const TITLE = "Mahindra Treo Zor Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Mahindra Treo Zor price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "Mahindra Treo Zor, Mahindra electric vehicle, Mahindra electric cargo vehicle, Mahindra electric commercial vehicle, Mahindra Treo Zor price, Mahindra Treo Zor specifications, Mahindra Treo Zor range, Mahindra Treo Zor load capacity, Mahindra electric vehicle price, Mahindra commercial vehicle, Mahindra electric auto, Mahindra EV, Mahindra electric truck, Mahindra cargo vehicle, Mahindra electric vehicle specifications, Mahindra electric vehicle features, Mahindra electric vehicle reviews, Mahindra electric vehicle dealer, Mahindra Treo Zor electric truck, Mahindra electric three wheeler",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/Treo-Zor",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/Treo-Zor",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Mahindra Treo Zor Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Mahindra Treo Zor price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Mahindra Treo Zor price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Mahindra Treo Zor Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/Treo-Zor",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Mahindra/Treo-Zor";

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const HIGHLIGHTS_DESCRIPTION = "The Mahindra Treo Zor Electric Gaadi is a heavy-duty electric three-wheeler that can carry up to 550 kg of cargo for 80 km on a single charge. It also has a 3-way cargo tray that can be configured in multiple ways which enables easy and fast loading and unloading. Treo Zor is available in pickup, cargo van, and flatbed variants, so you can choose the one that best fits your business requirements.";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING = "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Mahindra Treo Zor";

export const BRAND_DEALER_HEADING = "Mahindra Treo Zor Electric Truck Dealers Near Me:";

export const BRAND_DEALER_DESCRIPITION = "As Mahindra's influence continues to extend across India, its presence is becoming increasingly noticeable. With a rising number of individuals choosing Mahindra's top-notch mobility solutions, known for delivering excellent value for the price, Turno proudly presents the outstanding Mahindra Treo Zor electric commercial vehicle, at an unbelievably budget-friendly price.";

export const FAQ_HEADING_TEXT = "FAQs on Mahindra Treo Zor";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Mahindra", href: "/electric-commercial-vehicles/Mahindra" },
  { label: "Treo Zor" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Mahindra",
      item: "https://www.turno.club/electric-commercial-vehicles/Mahindra",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Treo Zor",
      item: VEHICLE_LINK,
    },
  ],
};